export default __webpack_public_path__ + "static/media/qwiklabs3.1fa54c0d.png";